import { createSelector } from 'reselect';

const getUsername = state => state.auth.username;
const getPermissions = state => state.auth.permissions;
const getIsLogginIn = state => state.auth.isLogginIn;
const getIsAdmin = state => state.auth.isAdmin;
const getIsSending = state => state.auth.passwordReset.isSending;
const getEmail = state => state.auth.passwordReset.email;
const getSecurityCode = state => state.auth.passwordReset.securityCode;
const getIsReseting = state => state.auth.passwordReset.isReseting;
const getSupportConnection = state => state.auth.supportConnection;

export const usernameSelector = createSelector(
    getUsername,
    username => username
);

export const permissionsSelector = createSelector(
    getPermissions,
    permissions => permissions
);

export const isLogginInSelector = createSelector(
    getIsLogginIn,
    isLogginIn => isLogginIn
);

export const isAdminSelector = createSelector(
    getIsAdmin,
    isAdmin => isAdmin
);

export const isSendingSelector = createSelector(
    getIsSending,
    isSending => isSending
);

export const emailSelector = createSelector(
    getEmail,
    email => email
);

export const securityCodeSelector = createSelector(
    getSecurityCode,
    securityCode => securityCode
);

export const isResetingSelector = createSelector(
    getIsReseting,
    isReseting => isReseting
);

export const supportConnectionSelector = createSelector(
    getSupportConnection,
    supportConnection => supportConnection
);
